require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-what-you-shouldn-t-put-on-your-resume.json") })
        }
      }, "path---blog-what-you-shouldn-t-put-on-your-resume");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-what-you-shouldn-t-put-on-your-resume!./.cache/json/blog-what-you-shouldn-t-put-on-your-resume.json
// module id = 1140
// module chunks = 231608221292675